import { render, staticRenderFns } from "./pay-3.vue?vue&type=template&id=cafe9cf2&scoped=true&"
import script from "./pay-3.vue?vue&type=script&lang=js&"
export * from "./pay-3.vue?vue&type=script&lang=js&"
import style0 from "./pay-3.vue?vue&type=style&index=0&id=cafe9cf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafe9cf2",
  null
  
)

export default component.exports